import { useState } from "react";

function useSelected(values, initial, allwaysSelected = false) {
	const [selected, setSelected] = useState(initial || []);

	const checkAll = () => {
		if (values?.length === selected?.length) {
			setSelected([]);
		} else {
			setSelected(values);
		}
	};

	const check = (id) => {
		if (selected.includes(id)) {
			if (selected.length === 1 && allwaysSelected) return;
			const idx = selected.indexOf(id);
			if (idx > -1) {
				const newSelected = [].concat(selected);
				newSelected.splice(idx, 1);
				setSelected(newSelected);
			}
		} else {
			setSelected([...selected, id]);
		}
	};

	// ** Zaznaczenie wielu elementów
	const checkMultiple = (idsArray) => {
		const toCheck = [];
		idsArray.forEach((id) => {
			if (!selected.includes(id)) {
				toCheck.push(id);
			}
		});
		setSelected([...selected, ...toCheck]);
	};

	// ** Odznaczenie wielu elementów
	const uncheckMultiple = (idsArray) => {
		const idsToUncheck = new Set(idsArray);
		const newSelected = selected.filter((id) => {
			return !idsToUncheck.has(id);
		});
		setSelected(newSelected);
	};

	const reset = () => {
		setSelected(initial || []);
	};

	const isChecked = (value) => selected?.includes(value);
	const checkAllDisabled = !values?.length;
	const isCheckedAll =
		!checkAllDisabled && selected && selected?.length === values?.length;
	const hasSelected = Boolean(selected?.length);

	return {
		selected,
		setSelected,
		hasSelected,
		isChecked,
		isCheckedAll,
		check,
		checkAll,
		checkMultiple,
		uncheckMultiple,
		checkAllDisabled,
		reset,
	};
}

export default useSelected;
